module.exports = __webpack_public_path__ + "static/media/banmedica.30d888ce.png";